(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  // Marquee — clone original items until track width >= 2 viewport widths, so
  // translateX(-50%) never reveals an empty gap. Duration scales with content
  // for constant px/sec speed.
  (function () {
    const bars = document.querySelectorAll('[data-announcement]');
    bars.forEach((bar) => {
      const track = bar.querySelector('.announcement__track');
      const viewport = bar.querySelector('.announcement__viewport');
      if (!track || !viewport) return;

      const speed = parseFloat(bar.dataset.speed) || 80;
      const originalChildren = Array.from(track.children).map((n) => n.cloneNode(true));

      const clearTrack = () => {
        while (track.firstChild) track.removeChild(track.firstChild);
      };

      const apply = () => {
        clearTrack();
        originalChildren.forEach((n) => track.appendChild(n.cloneNode(true)));

        const target = viewport.offsetWidth * 2;
        let safety = 0;
        while (track.scrollWidth < target && safety < 12) {
          const snapshot = Array.from(track.children).map((n) => n.cloneNode(true));
          snapshot.forEach((n) => track.appendChild(n));
          safety++;
        }

        const halfWidth = track.scrollWidth / 2;
        const duration = Math.max(8, halfWidth / speed);
        track.style.animationDuration = duration + 's';
      };

      const ready = ('fonts' in document) ? document.fonts.ready : Promise.resolve();
      ready.then(() => requestAnimationFrame(apply));

      let resizeT;
      window.addEventListener('resize', () => {
        clearTimeout(resizeT);
        resizeT = setTimeout(apply, 200);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    const lockScroll = (lock) => {
      document.documentElement.style.overflow = lock ? 'hidden' : '';
    };

    const openDrawer = () => {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      lockScroll(true);
    };

    const closeDrawer = () => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      lockScroll(false);
    };

    // Expose globally so other sections can trigger
    window.HumminCart = {
      open: openDrawer,
      close: closeDrawer,
      refresh: refreshDrawer,
    };

    // Click handlers (event delegation so they survive innerHTML replacement)
    drawer.addEventListener('click', (e) => {
      const close = e.target.closest('[data-cart-close]');
      if (close) {
        e.preventDefault();
        closeDrawer();
        return;
      }

      const qtyBtn = e.target.closest('[data-cart-qty-change]');
      if (qtyBtn) {
        const stepper = qtyBtn.closest('[data-cart-qty]');
        const key = stepper?.dataset.key;
        const delta = parseInt(qtyBtn.dataset.cartQtyChange, 10);
        const currentEl = stepper.querySelector('.qty-stepper__val');
        const current = parseInt(currentEl.textContent, 10) || 0;
        const next = Math.max(0, current + delta);
        changeCartItem(key, next);
        return;
      }

      const removeBtn = e.target.closest('[data-cart-remove]');
      if (removeBtn) {
        const key = removeBtn.dataset.key;
        changeCartItem(key, 0);
      }
    });

    // ESC to close
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    // Open drawer when any [data-cart-open] is clicked
    document.addEventListener('click', (e) => {
      const opener = e.target.closest('[data-cart-open]');
      if (!opener) return;
      e.preventDefault();
      openDrawer();
    });

    async function refreshDrawer() {
      try {
        const res = await fetch(`${window.Shopify?.routes?.root || '/'}?sections=cart-drawer`);
        const data = await res.json();
        const html = data['cart-drawer'];
        if (!html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newBody = doc.querySelector('[data-cart-body]');
        const newFooter = doc.querySelector('[data-cart-footer]');
        const newCount = doc.querySelector('[data-cart-count]');

        const currentBody = drawer.querySelector('[data-cart-body]');
        const currentFooter = drawer.querySelector('[data-cart-footer]');
        const existingFooterWrap = drawer.querySelector('.cart-drawer__panel');

        if (newBody && currentBody) currentBody.innerHTML = newBody.innerHTML;
        if (newCount) {
          drawer.querySelector('[data-cart-count]').textContent = newCount.textContent;
        }
        if (newFooter) {
          if (currentFooter) currentFooter.replaceWith(newFooter);
          else existingFooterWrap.appendChild(newFooter);
        } else if (currentFooter) {
          currentFooter.remove();
        }

        // Update all cart count labels across the site
        const bodyDoc = doc.querySelector('[data-cart-count]');
        if (bodyDoc) {
          const count = bodyDoc.textContent;
          document.querySelectorAll('[data-cart-count]').forEach((el) => {
            el.textContent = count;
          });
        }
      } catch (err) {
        console.error('Cart refresh failed:', err);
      }
    }

    async function changeCartItem(key, quantity) {
      drawer.classList.add('is-loading');
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity }),
        });
        await refreshDrawer();
      } catch (err) {
        console.error('Cart update failed:', err);
      } finally {
        drawer.classList.remove('is-loading');
      }
    }

    // Intercept product form submissions — add to cart via fetch, then open drawer
    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      if (form.dataset.noDrawer === 'true') return;

      e.preventDefault();
      const submitBtn = form.querySelector('[type="submit"]');
      const originalLabel = submitBtn?.querySelector('[data-atc-label]')?.textContent;
      if (submitBtn) {
        submitBtn.disabled = true;
        const lbl = submitBtn.querySelector('[data-atc-label]');
        if (lbl) lbl.textContent = 'Adding...';
      }

      try {
        const formData = new FormData(form);
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { Accept: 'application/json' },
        });
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.description || err.message || 'Add to cart failed');
        }
        await refreshDrawer();
        openDrawer();
      } catch (err) {
        console.error(err);
        alert(err.message || 'Could not add to cart. Please try again.');
      } finally {
        if (submitBtn) {
          submitBtn.disabled = false;
          const lbl = submitBtn.querySelector('[data-atc-label]');
          if (lbl && originalLabel) lbl.textContent = originalLabel;
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const page = document.querySelector('[data-cart-page]');
    if (!page) return;

    page.addEventListener('click', async (e) => {
      const qtyBtn = e.target.closest('[data-cart-qty-change]');
      const removeBtn = e.target.closest('[data-cart-remove]');

      if (qtyBtn) {
        const stepper = qtyBtn.closest('[data-cart-qty]');
        const key = stepper.dataset.key;
        const delta = parseInt(qtyBtn.dataset.cartQtyChange, 10);
        const valEl = stepper.querySelector('.qty-stepper__val');
        const current = parseInt(valEl.textContent, 10) || 0;
        const next = Math.max(0, current + delta);
        await updateItem(key, next);
      }

      if (removeBtn) {
        const key = removeBtn.dataset.key;
        await updateItem(key, 0);
      }
    });

    async function updateItem(key, quantity) {
      page.style.opacity = '0.5';
      page.style.pointerEvents = 'none';
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity }),
        });
        window.location.reload();
      } catch (err) {
        console.error('Cart update failed', err);
        page.style.opacity = '';
        page.style.pointerEvents = '';
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-collection]');
    if (!root) return;

    // Sort: auto-submit form on change
    root.querySelector('[data-sort-form]')?.addEventListener('change', (e) => {
      e.target.closest('form').submit();
    });

    // Filter toggle on mobile
    const toggle = root.querySelector('[data-filter-toggle]');
    const filters = root.querySelector('[data-filters]');
    if (toggle && filters) {
      toggle.addEventListener('click', () => {
        const open = filters.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-in"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-featured-in]').forEach((section) => {
      const quoteEl = section.querySelector('[data-featured-quote] .featured-in__quote-text');
      const logos = section.querySelectorAll('.featured-in__logo');
      if (!quoteEl || logos.length < 2) return;

      let active = 0;
      let timer;
      const ROTATE_MS = 8000;

      const setActive = (idx) => {
        if (idx === active) return;
        quoteEl.classList.add('is-fading');
        setTimeout(() => {
          quoteEl.textContent = logos[idx].dataset.quote;
          quoteEl.classList.remove('is-fading');
        }, 320);
        logos[active].classList.remove('is-active');
        logos[active].setAttribute('aria-selected', 'false');
        logos[idx].classList.add('is-active');
        logos[idx].setAttribute('aria-selected', 'true');
        active = idx;
      };

      const tick = () => setActive((active + 1) % logos.length);

      const startTimer = () => {
        clearInterval(timer);
        timer = setInterval(tick, ROTATE_MS);
      };

      logos.forEach((logo) => {
        logo.addEventListener('click', () => {
          setActive(parseInt(logo.dataset.index, 10));
          startTimer();
        });
      });

      // Pause when not in viewport
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) startTimer();
            else clearInterval(timer);
          });
        }, { threshold: 0.3 });
        io.observe(section);
      } else {
        startTimer();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const header = document.querySelector('[data-header-rv]');
    const drawer = document.querySelector('[data-drawer-rv]');
    if (!header) return;

    if (!drawer) return;
    const open = () => {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('has-drawer-open');
      const toggle = header.querySelector('[data-drawer-open]');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
    };
    const close = () => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('has-drawer-open');
      const toggle = header.querySelector('[data-drawer-open]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    };
    document.querySelectorAll('[data-drawer-open]').forEach((el) => el.addEventListener('click', open));
    document.querySelectorAll('[data-drawer-close]').forEach((el) => el.addEventListener('click', close));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  (function () {
    const newToggle = document.querySelector('[data-new-address-toggle]');
    const newPanel = document.querySelector('[data-new-address-panel]');
    const newCancel = document.querySelector('[data-new-address-cancel]');

    newToggle?.addEventListener('click', () => {
      newPanel.removeAttribute('hidden');
      newPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    newCancel?.addEventListener('click', () => newPanel.setAttribute('hidden', ''));

    document.querySelectorAll('[data-edit-toggle]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const id = btn.dataset.editToggle;
        const panel = document.querySelector(`[data-edit-panel="${id}"]`);
        panel?.removeAttribute('hidden');
        panel?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    document.querySelectorAll('[data-edit-cancel]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const id = btn.dataset.editCancel;
        document.querySelector(`[data-edit-panel="${id}"]`)?.setAttribute('hidden', '');
      });
    });

    document.querySelectorAll('[data-confirm-message]').forEach((form) => {
      form.addEventListener('submit', (e) => {
        if (!confirm(form.dataset.confirmMessage)) e.preventDefault();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  (function () {
    const toggle = document.querySelector('[data-recover-toggle]');
    const close = document.querySelector('[data-recover-close]');
    const panel = document.querySelector('[data-recover-panel]');
    const login = document.getElementById('login');
    if (!toggle || !panel || !login) return;

    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      panel.removeAttribute('hidden');
      panel.querySelector('input[type="email"]')?.focus();
      panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    close?.addEventListener('click', (e) => {
      e.preventDefault();
      panel.setAttribute('hidden', '');
      login.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    if (window.location.hash === '#recover') {
      panel.removeAttribute('hidden');
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mission-rv"] && !Shopify.designMode) return;
  try {
    
  // Mission — three behaviors:
  //   1. Word-split each heading (per-phase)
  //   2. IntersectionObserver → adds .is-revealed (triggers Phase-1 cascade)
  //   3. Scroll handler → tracks section progress, toggles .is-phase-2 at 50% (triggers Phase-2 cascade)
  //                       + applies sachet rotation parallax (Revivr port)
  (() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const splitHeading = (heading) => {
      if (!heading || heading.classList.contains('is-split')) return;
      const text = heading.textContent.trim();
      heading.textContent = '';
      text.split(/(\s+)/).forEach((part) => {
        if (!part.length) return;
        if (/^\s+$/.test(part)) {
          heading.appendChild(document.createTextNode(part));
        } else {
          const wrap = document.createElement('span');
          wrap.className = 'word';
          const inner = document.createElement('span');
          inner.className = 'word-inner';
          inner.textContent = part;
          wrap.appendChild(inner);
          heading.appendChild(wrap);
        }
      });
      heading.querySelectorAll('.word-inner').forEach((w, i) => {
        w.style.transitionDelay = (200 + i * 70) + 'ms';
      });
      heading.classList.add('is-split');
    };

    const init = () => {
      const root = document.querySelector('[data-mission-rv]');
      if (!root) return;

      // 1. Split BOTH phase headings
      root.querySelectorAll('.mission-rv__heading').forEach(splitHeading);

      // 2. Reveal trigger — observe the inner sticky panel (not the 350vh outer)
      //    so threshold fires reliably when the centered content is in view.
      if (reduce || !('IntersectionObserver' in window)) {
        root.classList.add('is-revealed');
      } else {
        const target = root.querySelector('.mission-rv__content') || root;
        const obs = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              root.classList.add('is-revealed');
              obs.disconnect();
            }
          });
        }, { threshold: 0, rootMargin: '0px 0px -5% 0px' });
        obs.observe(target);
        // Safety fallback: if for any reason IO doesn't fire within 4s while section is on screen,
        // trigger reveal anyway so text never stays invisible.
        setTimeout(() => {
          if (!root.classList.contains('is-revealed')) {
            const r = root.getBoundingClientRect();
            if (r.top < window.innerHeight && r.bottom > 0) root.classList.add('is-revealed');
          }
        }, 4000);
      }

      // 3. Scroll handler — phase progression + sachet rotation (RAF-batched)
      const images = Array.from(root.querySelectorAll('[data-mission-img]'));
      const maxRotation = 90;
      let ticking = false;

      const apply = () => {
        ticking = false;
        // Phase progression — toggle .is-phase-2 at 50% through the section
        const rect = root.getBoundingClientRect();
        const total = root.offsetHeight - window.innerHeight;
        const progress = total > 0 ? Math.max(0, Math.min(1, -rect.top / total)) : 0;
        if (progress >= 0.5) root.classList.add('is-phase-2');
        else root.classList.remove('is-phase-2');

        // Sachet rotation (skip on reduced motion)
        if (reduce || !images.length) return;
        const vh = window.innerHeight;
        images.forEach((image) => {
          const r = image.getBoundingClientRect();
          // Apply rotation across full lifecycle (not just intersecting): below = 0, in view = ramp, above = max.
          let visiblePercent;
          if (r.top >= vh) visiblePercent = 0;            // below viewport → 0 deg
          else if (r.bottom <= 0) visiblePercent = 100;   // above viewport → max deg (frozen)
          else visiblePercent = ((vh - r.top) / vh) * 100;
          let rotation = Math.min(Math.max(visiblePercent, 0), 100) / 100 * maxRotation;
          if (image.classList.contains('mission-rv__img--odd')) rotation *= -1;
          image.style.transform = `translate3d(0,0,0) rotate(${rotation.toFixed(2)}deg)`;
        });
      };

      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(apply);
      };
      document.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });

      // Initial pass — set transforms immediately so images aren't visually 0deg flat before user scrolls
      apply();
      // Re-run after image load so first paint is correct
      images.forEach((img) => {
        if (!img.complete) img.addEventListener('load', apply, { once: true });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-product-section]');
    if (!root) return;

    // Gallery thumbnail swap
    const slides = root.querySelectorAll('.product__gallery-slide');
    const thumbs = root.querySelectorAll('.product__gallery-thumb');
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const idx = thumb.dataset.thumbIndex;
        slides.forEach((s) => {
          const active = s.dataset.slideIndex === idx;
          s.classList.toggle('is-active', active);
          if (active) s.removeAttribute('aria-hidden');
          else s.setAttribute('aria-hidden', 'true');
        });
        thumbs.forEach((t) => {
          const active = t.dataset.thumbIndex === idx;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      });
    });

    // Quantity stepper
    const stepper = root.querySelector('[data-qty-stepper]');
    if (stepper) {
      const input = stepper.querySelector('[data-qty-input]');
      stepper.querySelector('[data-qty-dec]')?.addEventListener('click', () => {
        const v = Math.max(1, parseInt(input.value, 10) - 1);
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      stepper.querySelector('[data-qty-inc]')?.addEventListener('click', () => {
        const v = parseInt(input.value, 10) + 1;
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    // Purchase option toggle + selling plan binding
    const options = root.querySelectorAll('.purchase-option');
    const sellingPlanInput = root.querySelector('[data-selling-plan-input]');
    const syncSellingPlan = (input) => {
      if (!sellingPlanInput) return;
      sellingPlanInput.value = input.dataset.sellingPlanId || '';
    };
    options.forEach((opt) => {
      const input = opt.querySelector('input[type="radio"]');
      if (!input) return;
      input.addEventListener('change', () => {
        if (input.checked) {
          options.forEach((o) => o.classList.remove('is-selected'));
          opt.classList.add('is-selected');
          syncSellingPlan(input);
        }
      });
      opt.addEventListener('click', (e) => {
        if (e.target.tagName !== 'INPUT') {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
    const initialChecked = root.querySelector('.purchase-option input[type="radio"]:checked');
    if (initialChecked) syncSellingPlan(initialChecked);

    // Variant radio toggle
    const variantOpts = root.querySelectorAll('.product__option-value');
    variantOpts.forEach((opt) => {
      const input = opt.querySelector('input[type="radio"]');
      if (!input) return;
      input.addEventListener('change', () => {
        opt.parentElement.querySelectorAll('.product__option-value').forEach((o) => o.classList.remove('is-selected'));
        opt.classList.add('is-selected');
      });
    });

    // Mobile sticky bar: show when main ATC is out of viewport
    const mobileBar = root.querySelector('[data-mobile-bar]');
    const atcBtn = root.querySelector('[data-atc-btn]');
    const mobileCta = root.querySelector('[data-mobile-cta]');
    if (mobileBar && atcBtn) {
      const io = new IntersectionObserver(
        ([entry]) => {
          const show = !entry.isIntersecting && window.innerWidth < 1024;
          mobileBar.classList.toggle('is-visible', show);
          mobileBar.setAttribute('aria-hidden', show ? 'false' : 'true');
        },
        { threshold: 0, rootMargin: '-80px 0px 0px 0px' }
      );
      io.observe(atcBtn);
      mobileCta?.addEventListener('click', () => {
        root.querySelector('#product-form')?.requestSubmit();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
